module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-product-list"
  }, _vm._l((_vm.productItems), function(product) {
    return _c('a', {
      key: product.code,
      staticClass: "w-product-list__item",
      attrs: {
        "href": product.url
      }
    }, [_c('img', {
      staticClass: "w-product-list__item-image",
      attrs: {
        "src": product.logoUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "w-product-list__item-content"
    }, [_c('h5', {
      staticClass: "w-product-list__item--title"
    }, [_vm._v(_vm._s(product.title))]), _vm._v(" "), _c('div', {
      staticClass: "w-product-list__item--description"
    }, [_vm._v(_vm._s(product.description))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57946abe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ProductList.vue
// module id = 599
// module chunks = 1